import TigerBugsnag from '@tiger/bugsnag';
import { language } from 'utils/i18n';
import pkg from 'package.json';
import { rules } from './ignore';

const { Bugsnag, ErrorBoundary, notifyAPIError } = TigerBugsnag({
    apiKey: pkg.bugsnag,
    appVersion: pkg.version,
    appType: 'web',
    language,
    shouldReport: process.env.NODE_ENV === 'production',
    ignoreRules: rules,
    maskFields: [
        'id_no',
        'email',
        'real_name',
        'real_name_en',
        'birthday',
        'pinyin_first',
        'pinyin_last',
        'first_name',
        'last_name',
        'home_address',
        'phone'
    ]
});

export { ErrorBoundary, Bugsnag, notifyAPIError };
